// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/App.css */

/* ============================================
   ГЛОБАЛЬНЫЕ СТИЛИ И СБРОС
============================================ */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
  color: #2c3e50;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ============================================
   ОСНОВНОЙ МАКЕТ
============================================ */
.app {
  display: flex;
  min-height: 100vh;
}

/* ============================================
   САЙДБАР (НАВИГАЦИЯ)
============================================ */
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a2639 0%, #0f1a2f 100%);
  color: #e0e0e0;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.selected-label {
  padding: 0 20px 16px 20px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #8a9bb5;
  border-bottom: 1px solid #2a3650;
  margin-bottom: 16px;
}

.nav-section {
  margin-bottom: 24px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #b0c4de;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  border-left: 3px solid transparent;
  position: relative;
}

.nav-item i {
  width: 20px;
  font-size: 16px;
  color: #5f7d9c;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  border-left-color: #4a90e2;
}

.nav-item:hover i {
  color: #4a90e2;
}

.nav-item.active {
  background: rgba(74, 144, 226, 0.15);
  color: #ffffff;
  border-left-color: #4a90e2;
}

.nav-item.active i {
  color: #4a90e2;
}

.nav-badge {
  position: absolute;
  right: 20px;
  background: #4a90e2;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}

.user-section {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #2a3650;
}

.user-info-compact {
  padding: 12px 20px 4px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #b0c4de;
}

.user-info-compact i {
  font-size: 20px;
  color: #4a90e2;
}

.user-info-compact .user-email {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-time-compact {
  padding: 4px 20px 12px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #8a9bb5;
}

.user-time-compact i {
  font-size: 12px;
}

.logout-nav-btn {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #ff6b6b;
  border-top: 1px solid #2a3650;
  margin-top: 8px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.logout-nav-btn:hover {
  background: rgba(255, 107, 107, 0.1);
  color: #ff8a8a;
}

/* ============================================
   ОСНОВНОЙ КОНТЕНТ И ХЕДЕР
============================================ */
.main-content {
  flex: 1 1;
  padding: 24px 32px;
  overflow-y: auto;
  background: #f5f7fa;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  background: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title i {
  color: #4a90e2;
  font-size: 28px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 24px;
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-email {
  font-weight: 500;
  color: #2c3e50;
}

.user-time {
  font-size: 12px;
  color: #8a9bb5;
  display: flex;
  align-items: center;
  gap: 4px;
}

.logout-btn {
  background: #ff6b6b;
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
}

.logout-btn:hover {
  background: #ff5252;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);
}

/* ============================================
   СЕТКА КАРТОЧЕК НА ГЛАВНОЙ
============================================ */
.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border: 1px solid #e9ecef;
}

.card.clickable {
  cursor: pointer;
}

.card.clickable:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-color: #4a90e2;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.card-icon i {
  font-size: 24px;
  color: white;
}

.card-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.card-description {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 16px;
  min-height: 60px;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #8a9bb5;
  border-top: 1px solid #e9ecef;
  padding-top: 16px;
}

/* ============================================
   КАРТОЧКИ СЕРВЕРОВ И LXC
============================================ */
.lxc-container {
  padding: 0;
}

.lxc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.lxc-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.add-lxc-btn {
  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.add-lxc-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

/* ✅ НОВЫЕ СТИЛИ ДЛЯ КНОПКИ ЗАПУСКА */
.launch-lxc-btn {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;
  border-color: #28a745 !important;
}

.launch-lxc-btn:hover {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%) !important;
  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);
}

.lxc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.server-card {
  position: relative;
  padding: 0;
  overflow: hidden;
}

.card-status {
  padding: 16px 20px 8px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
}

.status-indicator {
  font-size: 14px;
  font-weight: 500;
}

.status-indicator.running { color: #28a745; }
.status-indicator.stopped { color: #dc3545; }

.databases-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #e3f2fd;
  color: #0d47a1;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.databases-badge i { font-size: 11px; }

.server-card .card-title {
  padding: 0 20px;
  margin: 12px 0;
  font-size: 18px;
}

.server-card .card-description {
  padding: 0 20px;
  min-height: auto;
}

.info-row {
  margin-bottom: 8px;
  font-size: 14px;
  color: #495057;
}

.info-row strong {
  color: #2c3e50;
  width: 80px;
  display: inline-block;
}

.info-row.databases-row {
  margin-top: 8px;
  margin-bottom: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.info-row.databases-row strong {
  display: block;
  margin-bottom: 4px;
  width: auto;
  font-size: 12px;
  color: #333;
}

/* ============================================
   СПИСОК БАЗ ДАННЫХ (ОПТИМИЗИРОВАННЫЙ)
============================================ */
.databases-list-container {
  margin-top: 8px;
  width: 100%;
}

.databases-header-static {
  display: flex;
  align-items: center;
  padding: 4px 0;
  color: #333;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 6px;
}

.databases-items-static {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 8px;
  border: 1px solid #e9ecef;
  margin-left: 0;
  max-height: 300px;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
}

.databases-items-static::-webkit-scrollbar { width: 6px; }
.databases-items-static::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }
.databases-items-static::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
.databases-items-static::-webkit-scrollbar-thumb:hover { background: #999; }

.database-item-static {
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  border-radius: 4px;
  cursor: default;
}

.database-item-static:last-child { border-bottom: none; }
.database-item-static:hover { background-color: #f0f0f0; }

.db-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.db-info i {
  color: #4a90e2;
  font-size: 12px;
  width: 16px;
}

.db-name-link {
  font-size: 13px;
  color: #0066cc;
  text-decoration: none;
  cursor: pointer !important;
  font-weight: 500;
  transition: color 0.2s;
  position: relative;
  z-index: 10;
}

.db-name-link:hover {
  color: #004999;
  text-decoration: underline;
}

.db-details {
  display: flex;
  gap: 10px;
  font-size: 11px;
  color: #666;
  margin-left: 26px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.db-size, .db-type, .db-status, .db-connections {
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
}

.db-size { background-color: #e9ecef; color: #495057; }
.db-type { background-color: #e9ecef; color: #6c757d; }
.db-status { background-color: #e9ecef; }
.db-status.active { color: #28a745; background-color: #e8f5e9; }
.db-status.error { color: #dc3545; background-color: #ffebee; }
.db-connections { background-color: #e9ecef; }
.db-connections i { margin-right: 2px; font-size: 8px; }

.databases-empty {
  padding: 8px 12px;
  color: #8a9bb5;
  font-style: italic;
  font-size: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  text-align: center;
  margin-left: 0;
}

/* ============================================
   РЕСУРСЫ И ДЕЙСТВИЯ КОНТЕЙНЕРА
============================================ */
.resources {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 16px 0;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.resource-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 13px;
}

.resource-item strong {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 2px;
}

.server-card .card-meta {
  padding: 12px 20px;
  margin: 0;
  border-top: 1px solid #e9ecef;
}

.card-actions {
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.action-btn {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.start-btn { background: #d4edda; color: #155724; }
.start-btn:hover:not(:disabled) { background: #c3e6cb; }

.stop-btn { background: #f8d7da; color: #721c24; }
.stop-btn:hover:not(:disabled) { background: #f5c6cb; }

.restart-btn { background: #fff3cd; color: #856404; }
.restart-btn:hover:not(:disabled) { background: #ffe8a1; }

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   СТАТУСЫ 1С
============================================ */
.onec-status-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 14px;
  margin-left: auto;
}

.onec-status-indicator.running { color: #28a745; background: rgba(40, 167, 69, 0.1); }
.onec-status-indicator.stopped { color: #ffc107; background: rgba(255, 193, 7, 0.1); }
.onec-status-indicator.container-stopped { color: #6c757d; background: rgba(108, 117, 125, 0.1); }
.onec-status-indicator.not-installed { color: #dc3545; background: rgba(220, 53, 69, 0.1); }

.onec-info-section {
  margin: 12px 0;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
}

.onec-status-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.onec-status-row strong {
  min-width: 30px;
  font-size: 13px;
}

.onec-status-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.onec-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.onec-badge.running { background: #d4edda; color: #155724; }
.onec-badge.stopped { background: #fff3cd; color: #856404; }
.onec-badge.container-stopped { background: #e2e3e5; color: #383d41; }
.onec-badge.not-installed { background: #f8d7da; color: #721c24; }

.onec-version-badge {
  padding: 2px 6px;
  background: #4a90e2;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.onec-versions-section {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #dee2e6;
}

.onec-versions-list small { color: #6c757d; }

.onec-service-btn {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.onec-service-btn.start-onec { background: #4a90e2; color: white; }
.onec-service-btn.start-onec:hover { background: #3575c0; }
.onec-service-btn.stop-onec { background: #ffc107; color: #856404; }
.onec-service-btn.stop-onec:hover { background: #e0a800; }

/* ============================================
   СТАТУСЫ APACHE2 И КЛАСТЕРА
============================================ */
.apache-info-section, .cluster-info-section {
  margin: 12px 0;
  padding: 12px;
  border-radius: 8px;
}

.apache-info-section {
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
  border: 1px solid #b3d9ff;
  border-left: 4px solid #4a90e2;
}

.cluster-info-section {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
  border: 1px solid #d8b4fe;
  border-left: 4px solid #9333ea;
}

.apache-status-row, .cluster-status-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.apache-status-row strong, .cluster-status-row strong {
  min-width: 75px;
  font-size: 13px;
  color: #2c3e50;
  font-weight: 600;
}

.apache-status-details, .cluster-status-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.apache-badge, .cluster-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
}

.apache-badge.running, .cluster-badge.created {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border: 1px solid #c3e6cb;
}

.apache-badge.stopped {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border: 1px solid #ffeaa7;
}

.apache-badge.not-installed, .cluster-badge.not-created {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.apache-badge.installing, .cluster-badge.creating {
  background: linear-gradient(135deg, #cce5ff 0%, #b3d9ff 100%);
  color: #004085;
  border: 1px solid #b3d9ff;
  animation: pulse 1.5s infinite;
}

.apache-badge.error, .cluster-badge.error {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border: 1px solid #f5c6cb;
}

@keyframes pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(74, 144, 226, 0.4); }
  50% { opacity: 0.85; box-shadow: 0 0 0 8px rgba(74, 144, 226, 0); }
}

.apache-install-btn {
  padding: 5px 12px;
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.apache-install-btn:hover {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.apache-service-btn {
  padding: 5px 12px;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.apache-service-btn.start-apache { background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%); color: white; }
.apache-service-btn.start-apache:hover { background: linear-gradient(135deg, #3575c0 0%, #2a65a8 100%); transform: translateY(-1px); }
.apache-service-btn.stop-apache { background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%); color: #856404; }
.apache-service-btn.stop-apache:hover { background: linear-gradient(135deg, #e0a800 0%, #c69500 100%); transform: translateY(-1px); }

.apache-status-message, .cluster-status-message {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.apache-status-message.success, .cluster-status-message.success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border: 1px solid #c3e6cb;
}

.apache-status-message.error, .cluster-status-message.error {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.apache-status-message.info, .cluster-status-message.info {
  background: linear-gradient(135deg, #e7f3ff 0%, #cce5ff 100%);
  color: #004085;
  border: 1px solid #b3d9ff;
}

/* ============================================
   ПУСТОЕ СОСТОЯНИЕ
============================================ */
.full-empty-state {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.full-empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
  color: #dee2e6;
}

.full-empty-text {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.full-empty-subtext {
  color: #6c757d;
  margin-bottom: 32px;
}

.add-server-btn {
  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.add-server-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

/* ============================================
   МОДАЛЬНЫЕ ОКНА
============================================ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
}

.lxc-modal {
  max-width: 700px;
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-header h3 i { color: #4a90e2; }

.close-modal-btn {
  background: none;
  border: none;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #8a9bb5;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.close-modal-btn:hover:not(:disabled) {
  background: #f8f9fa;
  color: #dc3545;
}

.close-modal-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   ФОРМЫ В МОДАЛЬНЫХ ОКНАХ
============================================ */
form { padding: 24px; }

.form-group { margin-bottom: 20px; }

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #495057;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.form-group input:disabled,
.form-group select:disabled,
.form-group textarea:disabled {
  background: #e9ecef;
  cursor: not-allowed;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.password-input-group {
  display: flex;
  gap: 8px;
}

.password-input-group input { flex: 1 1; }

.regenerate-password-btn {
  width: 42px;
  background: #e9ecef;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.regenerate-password-btn:hover:not(:disabled) {
  background: #dee2e6;
  color: #4a90e2;
}

.regenerate-password-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.password-hint {
  display: block;
  margin-top: 4px;
  color: #ff6b6b;
  font-size: 12px;
  font-weight: 500;
}

/* ============================================
   ИНФОРМАЦИЯ О КОНФИГУРАЦИИ И БАННЕР ШАБЛОНА
============================================ */
.specs-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.specs-info h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #495057;
}

.specs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.spec-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  align-items: center;
}

.spec-label { color: #6c757d; }
.spec-value { font-weight: 500; color: #2c3e50; }

.workflow-info {
  border-top: 1px solid #dee2e6;
  padding-top: 12px;
}

.workflow-info p {
  margin: 4px 0;
  font-size: 13px;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.workflow-info i { color: #4a90e2; }

/* ✅ НОВЫЙ БАННЕР ИНФОРМАЦИИ О ШАБЛОНЕ */
.template-info-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 1px solid #a5d6a7;
  border-left: 4px solid #28a745;
  border-radius: 8px;
  margin-bottom: 20px;
}

.template-info-banner i {
  font-size: 20px;
  color: #28a745;
  margin-top: 2px;
}

.template-info-banner strong {
  color: #1b5e20;
  font-size: 14px;
  display: block;
}

.template-info-banner code {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #2e7d32;
  font-weight: 600;
}

.template-info-banner small {
  display: block;
  margin-top: 6px;
  color: #2e7d32;
  font-size: 12px;
  line-height: 1.4;
}

/* ============================================
   СТАТУС СОЗДАНИЯ / ЗАПУСКА
============================================ */
.creation-status {
  margin: 0 24px 24px 24px;
  padding: 20px;
  border-radius: 8px;
}

.creation-status.info {
  background: #e7f3ff;
  border-left: 4px solid #4a90e2;
}

.creation-status.success {
  background: #d4edda;
  border-left: 4px solid #28a745;
}

.creation-status.error {
  background: #f8d7da;
  border-left: 4px solid #dc3545;
}

.status-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.step-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}

.step-icon.completed { background: #28a745; color: white; }
.step-icon.current { background: #4a90e2; color: white; }
.step-icon.pending { background: #e9ecef; color: #8a9bb5; }
.step-icon.error { background: #dc3545; color: white; }

.step-label {
  font-size: 11px;
  color: #6c757d;
}

.progress-line {
  flex: 1 1;
  height: 2px;
  background: #e9ecef;
  margin: 0 8px;
  position: relative;
}

.progress-line-fill {
  height: 100%;
  background: #4a90e2;
  transition: width 0.3s;
}

.progress-line-fill.filled { background: #28a745; }

.status-message {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  white-space: pre-line; /* ✅ Добавлено для корректного переноса строк из JS */
}

/* ============================================
   КНОПКИ ДЕЙСТВИЙ В МОДАЛКЕ
============================================ */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #e9ecef;
  color: #495057;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover:not(:disabled) {
  background: #dee2e6;
}

.cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #3575c0 0%, #2a65a8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* ✅ Кнопка отправки для модалки запуска */
.launch-submit-btn {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;
}

.launch-submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%) !important;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

/* ============================================
   ЗАГРУЗКА
============================================ */
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.spinner-large {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e9ecef;
  border-top: 3px solid #4a90e2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

/* ============================================
   АДАПТИВНОСТЬ
============================================ */
@media (max-width: 1024px) {
  .sidebar { width: 220px; }
  .lxc-grid { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); }
}

@media (max-width: 768px) {
  .app { flex-direction: column; }
  
  .sidebar {
    width: 100%;
    height: auto;
    position: static;
    padding: 16px;
  }
  
  .main-content { padding: 16px; }
  
  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .user-info {
    width: 100%;
    justify-content: space-between;
  }
  
  .user-details { align-items: flex-start; }
  .content-grid, .lxc-grid { grid-template-columns: 1fr; }
  
  .lxc-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .form-row, .specs-grid { grid-template-columns: 1fr; }
  
  .status-progress {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  
  .progress-line { display: none; }
  .info-row strong { width: 100%; margin-bottom: 4px; }
  .db-details { flex-direction: column; gap: 2px; }
  .db-size, .db-type { white-space: normal; text-align: right; }
  
  .apache-status-row, .cluster-status-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  
  .apache-status-row strong, .cluster-status-row strong { min-width: auto; }
  .apache-status-details, .cluster-status-details { width: 100%; justify-content: flex-start; }
  .databases-items-static { max-height: 200px; }
  .database-item-static { padding: 6px 8px; }
  .db-details { margin-left: 18px; gap: 6px; }
}

@media (max-width: 480px) {
  .modal-content { width: 95%; margin: 10px; }
  .card-actions { flex-direction: column; }
  .action-btn { width: 100%; }
  .resources { grid-template-columns: 1fr; }
  .database-item-static { flex-direction: column; align-items: flex-start; gap: 4px; }
  .db-details { margin-left: 24px; flex-direction: row; }
}

/* ============================================
   ДОПОЛНИТЕЛЬНЫЕ УТИЛИТЫ
============================================ */
.text-muted { color: #6c757d; }
.text-success { color: #28a745; }
.text-danger { color: #dc3545; }
.text-warning { color: #ffc107; }
.text-info { color: #4a90e2; }
.mt-2 { margin-top: 8px; }
.mb-2 { margin-bottom: 8px; }
.ml-2 { margin-left: 8px; }
.mr-2 { margin-right: 8px; }


/* ============================================
   СТИЛИ ДЛЯ СТРАНИЦЫ ВХОДА И РЕГИСТРАЦИИ
============================================ */
.auth-wrapper {
  min-height: 100vh;
  background: #0a0e1a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.auth-container {
  display: flex;
  width: 1200px;
  max-width: 95vw;
  min-height: 700px;
  background: #111827;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.auth-info-panel {
  width: 45%;
  padding: 48px 40px;
  background: linear-gradient(145deg, #1a1f35 0%, #0d1225 100%);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.auth-info-panel::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.auth-brand {
  margin-bottom: 48px;
  position: relative;
  z-index: 1;
}

.brand-icon { margin-bottom: 16px; }

.brand-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.5px;
}

.brand-subtitle {
  font-size: 16px;
  color: #8b9bb5;
  margin: 4px 0 16px 0;
  font-weight: 400;
}

.brand-badge {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge-mvp {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-status {
  display: inline-block;
  padding: 4px 12px;
  background: rgba(102, 126, 234, 0.2);
  color: #8b9bb5;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid rgba(102, 126, 234, 0.2);
}

.auth-features {
  flex: 1 1;
  position: relative;
  z-index: 1;
}

.features-title {
  font-size: 14px;
  font-weight: 600;
  color: #8b9bb5;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.features-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #c8d0e0;
  font-size: 13px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.3s ease;
}

.features-list li:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(102, 126, 234, 0.2);
}

.feature-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.feature-text {
  font-size: 12px;
  line-height: 1.3;
}

.auth-footer-info {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  position: relative;
  z-index: 1;
}

.footer-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.footer-badge {
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 6px;
  font-size: 11px;
  color: #6b7d98;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.footer-version {
  font-size: 12px;
  color: #4a5a70;
  margin: 0;
}

.auth-form-panel {
  width: 55%;
  padding: 48px 48px;
  background: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-form-panel .auth-card {
  width: 100%;
  max-width: 400px;
}

.auth-header { margin-bottom: 32px; }

.auth-title {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.auth-subtitle {
  font-size: 15px;
  color: #8b9bb5;
  margin: 0;
}

.auth-error {
  background: rgba(239, 68, 68, 0.1);
  border-left: 3px solid #ef4444;
  color: #fca5a5;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.auth-error i {
  font-size: 16px;
  color: #ef4444;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.auth-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.auth-form .form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #b0bfd4;
  display: flex;
  align-items: center;
  gap: 8px;
}

.auth-form .form-group label i {
  color: #4a6a8a;
  font-size: 13px;
}

.auth-form .input-wrapper { position: relative; }

.auth-form .input-wrapper input {
  width: 100%;
  padding: 12px 16px;
  background: #1a2236;
  border: 1.5px solid #2a3650;
  border-radius: 10px;
  font-size: 15px;
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
}

.auth-form .input-wrapper input::placeholder { color: #4a5a70; }

.auth-form .input-wrapper input:focus {
  border-color: #667eea;
  background: #1e2840;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.auth-form .input-wrapper input.filled { border-color: #3a4a6a; }
.auth-form .input-wrapper input:disabled { opacity: 0.5; cursor: not-allowed; }
.auth-form .password-wrapper input { padding-right: 48px; }

.auth-form .password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #4a5a70;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 16px;
  transition: color 0.3s ease;
}

.auth-form .password-toggle:hover:not(:disabled) { color: #8b9bb5; }
.auth-form .password-toggle:disabled { opacity: 0.5; cursor: not-allowed; }

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8b9bb5;
  cursor: pointer;
}

.remember-me input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #667eea;
  cursor: pointer;
}

.forgot-password {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #7b93f5;
  text-decoration: underline;
}

.auth-submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}

.auth-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.3);
}

.auth-submit-btn:active:not(:disabled) { transform: translateY(0); }
.auth-submit-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }

.auth-form .spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: auth-spin 0.8s linear infinite;
}

@keyframes auth-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.auth-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.auth-footer p {
  color: #6b7d98;
  font-size: 14px;
  margin: 0;
}

.auth-link {
  background: none;
  border: none;
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  padding: 0 4px;
  font-size: 14px;
  transition: color 0.3s ease;
}

.auth-link:hover:not(:disabled) {
  color: #7b93f5;
  text-decoration: underline;
}

.auth-link:disabled { opacity: 0.5; cursor: not-allowed; }

.auth-system-info {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.system-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  animation: pulse-dot 2s infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.2); }
}

.status-text {
  font-size: 13px;
  color: #8b9bb5;
}

.system-metrics {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #4a5a70;
}

.system-metrics span {
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 1024px) {
  .auth-container {
    flex-direction: column;
    max-height: none;
    max-width: 100%;
    margin: 20px;
    border-radius: 16px;
  }
  .auth-info-panel, .auth-form-panel {
    width: 100%;
    padding: 32px 28px;
  }
  .auth-features .features-list { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 640px) {
  .auth-info-panel, .auth-form-panel { padding: 24px 20px; }
  .auth-brand .brand-title { font-size: 24px; }
  .auth-title { font-size: 22px; }
  .auth-form .form-options {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .auth-system-info {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-badges { flex-direction: column; gap: 6px; }
  .system-metrics { flex-wrap: wrap; }
  .auth-features .features-list { grid-template-columns: 1fr; }
}

@media (max-width: 380px) {
  .auth-container { margin: 10px; border-radius: 12px; }
  .auth-info-panel, .auth-form-panel { padding: 20px 16px; }
  .auth-features .features-list li { font-size: 12px; padding: 6px 10px; }
  .auth-form .input-wrapper input { font-size: 14px; padding: 10px 14px; }
  .auth-submit-btn { font-size: 14px; padding: 12px; }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;;8CAE8C;AAC9C;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;8CAE8C;AAC9C;EACE,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;8CAE8C;AAC9C;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;8CAE8C;AAC9C;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;;AAE5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB,eAAe,EAAE;;AAEtC;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;;8CAE8C;AAC9C;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,6CAA6C,UAAU,EAAE;AACzD,mDAAmD,mBAAmB,EAAE,kBAAkB,EAAE;AAC5F,mDAAmD,gBAAgB,EAAE,kBAAkB,EAAE;AACzF,yDAAyD,gBAAgB,EAAE;;AAE3E;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,8BAA8B,yBAAyB,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW,yBAAyB,EAAE,cAAc,EAAE;AACtD,WAAW,yBAAyB,EAAE,cAAc,EAAE;AACtD,aAAa,yBAAyB,EAAE;AACxC,oBAAoB,cAAc,EAAE,yBAAyB,EAAE;AAC/D,mBAAmB,cAAc,EAAE,yBAAyB,EAAE;AAC9D,kBAAkB,yBAAyB,EAAE;AAC7C,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;;AAEvD;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE;;AAEvD,YAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,iCAAiC,mBAAmB,EAAE;;AAEtD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,oCAAoC,mBAAmB,EAAE;;AAEzD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,iCAAiC,cAAc,EAAE,kCAAkC,EAAE;AACrF,iCAAiC,cAAc,EAAE,kCAAkC,EAAE;AACrF,2CAA2C,cAAc,EAAE,oCAAoC,EAAE;AACjG,uCAAuC,cAAc,EAAE,kCAAkC,EAAE;;AAE3F;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA,+BAA+B,mBAAmB,EAAE,YAAY,EAAE;AAClE,qCAAqC,mBAAmB,EAAE;AAC1D,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,oCAAoC,mBAAmB,EAAE;;AAEzD;;8CAE8C;AAC9C;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW,UAAU,EAAE,2CAA2C,EAAE;EACpE,MAAM,aAAa,EAAE,2CAA2C,EAAE;AACpE;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA,mCAAmC,6DAA6D,EAAE,YAAY,EAAE;AAChH,yCAAyC,6DAA6D,EAAE,2BAA2B,EAAE;AACrI,kCAAkC,6DAA6D,EAAE,cAAc,EAAE;AACjH,wCAAwC,6DAA6D,EAAE,2BAA2B,EAAE;;AAEpI;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;8CAE8C;AAC9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;;8CAE8C;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qBAAqB,cAAc,EAAE;;AAErC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C,OAAO,aAAa,EAAE;;AAEtB,cAAc,mBAAmB,EAAE;;AAEnC;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,8BAA8B,SAAO,EAAE;;AAEvC;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;8CAE8C;AAC9C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA,cAAc,cAAc,EAAE;AAC9B,cAAc,gBAAgB,EAAE,cAAc,EAAE;;AAEhD;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB,cAAc,EAAE;;AAEnC,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;8CAE8C;AAC9C;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;;AAEtD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB,EAAE,qDAAqD;AAC9E;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;EACxE,4CAA4C;AAC9C;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C;EACE,WAAW,YAAY,EAAE;EACzB,YAAY,4DAA4D,EAAE;AAC5E;;AAEA;EACE,OAAO,sBAAsB,EAAE;;EAE/B;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA,gBAAgB,aAAa,EAAE;;EAE/B;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA,gBAAgB,uBAAuB,EAAE;EACzC,2BAA2B,0BAA0B,EAAE;;EAEvD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,yBAAyB,0BAA0B,EAAE;;EAErD;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA,iBAAiB,aAAa,EAAE;EAChC,mBAAmB,WAAW,EAAE,kBAAkB,EAAE;EACpD,cAAc,sBAAsB,EAAE,QAAQ,EAAE;EAChD,qBAAqB,mBAAmB,EAAE,iBAAiB,EAAE;;EAE7D;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA,wDAAwD,eAAe,EAAE;EACzE,kDAAkD,WAAW,EAAE,2BAA2B,EAAE;EAC5F,0BAA0B,iBAAiB,EAAE;EAC7C,wBAAwB,gBAAgB,EAAE;EAC1C,cAAc,iBAAiB,EAAE,QAAQ,EAAE;AAC7C;;AAEA;EACE,iBAAiB,UAAU,EAAE,YAAY,EAAE;EAC3C,gBAAgB,sBAAsB,EAAE;EACxC,cAAc,WAAW,EAAE;EAC3B,aAAa,0BAA0B,EAAE;EACzC,wBAAwB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EACnF,cAAc,iBAAiB,EAAE,mBAAmB,EAAE;AACxD;;AAEA;;8CAE8C;AAC9C,cAAc,cAAc,EAAE;AAC9B,gBAAgB,cAAc,EAAE;AAChC,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE;AAChC,aAAa,cAAc,EAAE;AAC7B,QAAQ,eAAe,EAAE;AACzB,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,iBAAiB,EAAE;;;AAG3B;;8CAE8C;AAC9C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,cAAc,mBAAmB,EAAE;;AAEnC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe,mBAAmB,EAAE;;AAEpC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B,kBAAkB,EAAE;;AAEhD;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA,+CAA+C,cAAc,EAAE;;AAE/D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,yCAAyC,qBAAqB,EAAE;AAChE,2CAA2C,YAAY,EAAE,mBAAmB,EAAE;AAC9E,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,mDAAmD,cAAc,EAAE;AACnE,uCAAuC,YAAY,EAAE,mBAAmB,EAAE;;AAE1E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,yCAAyC,wBAAwB,EAAE;AACnE,4BAA4B,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEhF;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,qBAAqB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA,gCAAgC,8BAA8B,EAAE;AAClE;;AAEA;EACE,qCAAqC,kBAAkB,EAAE;EACzD,2BAA2B,eAAe,EAAE;EAC5C,cAAc,eAAe,EAAE;EAC/B;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA,iBAAiB,sBAAsB,EAAE,QAAQ,EAAE;EACnD,kBAAkB,eAAe,EAAE;EACnC,gCAAgC,0BAA0B,EAAE;AAC9D;;AAEA;EACE,kBAAkB,YAAY,EAAE,mBAAmB,EAAE;EACrD,qCAAqC,kBAAkB,EAAE;EACzD,mCAAmC,eAAe,EAAE,iBAAiB,EAAE;EACvE,kCAAkC,eAAe,EAAE,kBAAkB,EAAE;EACvE,mBAAmB,eAAe,EAAE,aAAa,EAAE;AACrD","sourcesContent":["/* frontend/src/App.css */\n\n/* ============================================\n   ГЛОБАЛЬНЫЕ СТИЛИ И СБРОС\n============================================ */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f7fa;\n  color: #2c3e50;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ============================================\n   ОСНОВНОЙ МАКЕТ\n============================================ */\n.app {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* ============================================\n   САЙДБАР (НАВИГАЦИЯ)\n============================================ */\n.sidebar {\n  width: 260px;\n  background: linear-gradient(180deg, #1a2639 0%, #0f1a2f 100%);\n  color: #e0e0e0;\n  padding: 24px 0;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.selected-label {\n  padding: 0 20px 16px 20px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #8a9bb5;\n  border-bottom: 1px solid #2a3650;\n  margin-bottom: 16px;\n}\n\n.nav-section {\n  margin-bottom: 24px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  color: #b0c4de;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s;\n  border-left: 3px solid transparent;\n  position: relative;\n}\n\n.nav-item i {\n  width: 20px;\n  font-size: 16px;\n  color: #5f7d9c;\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  border-left-color: #4a90e2;\n}\n\n.nav-item:hover i {\n  color: #4a90e2;\n}\n\n.nav-item.active {\n  background: rgba(74, 144, 226, 0.15);\n  color: #ffffff;\n  border-left-color: #4a90e2;\n}\n\n.nav-item.active i {\n  color: #4a90e2;\n}\n\n.nav-badge {\n  position: absolute;\n  right: 20px;\n  background: #4a90e2;\n  color: white;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.user-section {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid #2a3650;\n}\n\n.user-info-compact {\n  padding: 12px 20px 4px 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #b0c4de;\n}\n\n.user-info-compact i {\n  font-size: 20px;\n  color: #4a90e2;\n}\n\n.user-info-compact .user-email {\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-time-compact {\n  padding: 4px 20px 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  color: #8a9bb5;\n}\n\n.user-time-compact i {\n  font-size: 12px;\n}\n\n.logout-nav-btn {\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #ff6b6b;\n  border-top: 1px solid #2a3650;\n  margin-top: 8px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logout-nav-btn:hover {\n  background: rgba(255, 107, 107, 0.1);\n  color: #ff8a8a;\n}\n\n/* ============================================\n   ОСНОВНОЙ КОНТЕНТ И ХЕДЕР\n============================================ */\n.main-content {\n  flex: 1;\n  padding: 24px 32px;\n  overflow-y: auto;\n  background: #f5f7fa;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  background: white;\n  padding: 16px 24px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2c3e50;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.page-title i {\n  color: #4a90e2;\n  font-size: 28px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.user-email {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.user-time {\n  font-size: 12px;\n  color: #8a9bb5;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.logout-btn {\n  background: #ff6b6b;\n  color: white;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 16px;\n}\n\n.logout-btn:hover {\n  background: #ff5252;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);\n}\n\n/* ============================================\n   СЕТКА КАРТОЧЕК НА ГЛАВНОЙ\n============================================ */\n.content-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s;\n  border: 1px solid #e9ecef;\n}\n\n.card.clickable {\n  cursor: pointer;\n}\n\n.card.clickable:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  border-color: #4a90e2;\n}\n\n.card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.card-icon i {\n  font-size: 24px;\n  color: white;\n}\n\n.card-title {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.card-description {\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 16px;\n  min-height: 60px;\n}\n\n.card-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #8a9bb5;\n  border-top: 1px solid #e9ecef;\n  padding-top: 16px;\n}\n\n/* ============================================\n   КАРТОЧКИ СЕРВЕРОВ И LXC\n============================================ */\n.lxc-container {\n  padding: 0;\n}\n\n.lxc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.lxc-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.add-lxc-btn {\n  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.add-lxc-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n}\n\n/* ✅ НОВЫЕ СТИЛИ ДЛЯ КНОПКИ ЗАПУСКА */\n.launch-lxc-btn {\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;\n  border-color: #28a745 !important;\n}\n\n.launch-lxc-btn:hover {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%) !important;\n  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);\n}\n\n.lxc-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.server-card {\n  position: relative;\n  padding: 0;\n  overflow: hidden;\n}\n\n.card-status {\n  padding: 16px 20px 8px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.status-indicator {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.status-indicator.running { color: #28a745; }\n.status-indicator.stopped { color: #dc3545; }\n\n.databases-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: #e3f2fd;\n  color: #0d47a1;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.databases-badge i { font-size: 11px; }\n\n.server-card .card-title {\n  padding: 0 20px;\n  margin: 12px 0;\n  font-size: 18px;\n}\n\n.server-card .card-description {\n  padding: 0 20px;\n  min-height: auto;\n}\n\n.info-row {\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: #495057;\n}\n\n.info-row strong {\n  color: #2c3e50;\n  width: 80px;\n  display: inline-block;\n}\n\n.info-row.databases-row {\n  margin-top: 8px;\n  margin-bottom: 12px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.info-row.databases-row strong {\n  display: block;\n  margin-bottom: 4px;\n  width: auto;\n  font-size: 12px;\n  color: #333;\n}\n\n/* ============================================\n   СПИСОК БАЗ ДАННЫХ (ОПТИМИЗИРОВАННЫЙ)\n============================================ */\n.databases-list-container {\n  margin-top: 8px;\n  width: 100%;\n}\n\n.databases-header-static {\n  display: flex;\n  align-items: center;\n  padding: 4px 0;\n  color: #333;\n  font-weight: 500;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.databases-items-static {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 8px;\n  border: 1px solid #e9ecef;\n  margin-left: 0;\n  max-height: 300px;\n  overflow-y: auto;\n  user-select: none;\n}\n\n.databases-items-static::-webkit-scrollbar { width: 6px; }\n.databases-items-static::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }\n.databases-items-static::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }\n.databases-items-static::-webkit-scrollbar-thumb:hover { background: #999; }\n\n.database-item-static {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 10px;\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s;\n  border-radius: 4px;\n  cursor: default;\n}\n\n.database-item-static:last-child { border-bottom: none; }\n.database-item-static:hover { background-color: #f0f0f0; }\n\n.db-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.db-info i {\n  color: #4a90e2;\n  font-size: 12px;\n  width: 16px;\n}\n\n.db-name-link {\n  font-size: 13px;\n  color: #0066cc;\n  text-decoration: none;\n  cursor: pointer !important;\n  font-weight: 500;\n  transition: color 0.2s;\n  position: relative;\n  z-index: 10;\n}\n\n.db-name-link:hover {\n  color: #004999;\n  text-decoration: underline;\n}\n\n.db-details {\n  display: flex;\n  gap: 10px;\n  font-size: 11px;\n  color: #666;\n  margin-left: 26px;\n  margin-top: 4px;\n  flex-wrap: wrap;\n}\n\n.db-size, .db-type, .db-status, .db-connections {\n  padding: 2px 6px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.db-size { background-color: #e9ecef; color: #495057; }\n.db-type { background-color: #e9ecef; color: #6c757d; }\n.db-status { background-color: #e9ecef; }\n.db-status.active { color: #28a745; background-color: #e8f5e9; }\n.db-status.error { color: #dc3545; background-color: #ffebee; }\n.db-connections { background-color: #e9ecef; }\n.db-connections i { margin-right: 2px; font-size: 8px; }\n\n.databases-empty {\n  padding: 8px 12px;\n  color: #8a9bb5;\n  font-style: italic;\n  font-size: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  text-align: center;\n  margin-left: 0;\n}\n\n/* ============================================\n   РЕСУРСЫ И ДЕЙСТВИЯ КОНТЕЙНЕРА\n============================================ */\n.resources {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin: 16px 0;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.resource-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  font-size: 13px;\n}\n\n.resource-item strong {\n  font-size: 11px;\n  color: #6c757d;\n  margin-bottom: 2px;\n}\n\n.server-card .card-meta {\n  padding: 12px 20px;\n  margin: 0;\n  border-top: 1px solid #e9ecef;\n}\n\n.card-actions {\n  display: flex;\n  gap: 8px;\n  padding: 16px 20px;\n  border-top: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.action-btn {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.start-btn { background: #d4edda; color: #155724; }\n.start-btn:hover:not(:disabled) { background: #c3e6cb; }\n\n.stop-btn { background: #f8d7da; color: #721c24; }\n.stop-btn:hover:not(:disabled) { background: #f5c6cb; }\n\n.restart-btn { background: #fff3cd; color: #856404; }\n.restart-btn:hover:not(:disabled) { background: #ffe8a1; }\n\n.action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   СТАТУСЫ 1С\n============================================ */\n.onec-status-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  font-size: 14px;\n  margin-left: auto;\n}\n\n.onec-status-indicator.running { color: #28a745; background: rgba(40, 167, 69, 0.1); }\n.onec-status-indicator.stopped { color: #ffc107; background: rgba(255, 193, 7, 0.1); }\n.onec-status-indicator.container-stopped { color: #6c757d; background: rgba(108, 117, 125, 0.1); }\n.onec-status-indicator.not-installed { color: #dc3545; background: rgba(220, 53, 69, 0.1); }\n\n.onec-info-section {\n  margin: 12px 0;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.onec-status-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.onec-status-row strong {\n  min-width: 30px;\n  font-size: 13px;\n}\n\n.onec-status-details {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.onec-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.onec-badge.running { background: #d4edda; color: #155724; }\n.onec-badge.stopped { background: #fff3cd; color: #856404; }\n.onec-badge.container-stopped { background: #e2e3e5; color: #383d41; }\n.onec-badge.not-installed { background: #f8d7da; color: #721c24; }\n\n.onec-version-badge {\n  padding: 2px 6px;\n  background: #4a90e2;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.onec-versions-section {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #dee2e6;\n}\n\n.onec-versions-list small { color: #6c757d; }\n\n.onec-service-btn {\n  width: 100%;\n  margin-top: 8px;\n  padding: 8px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.onec-service-btn.start-onec { background: #4a90e2; color: white; }\n.onec-service-btn.start-onec:hover { background: #3575c0; }\n.onec-service-btn.stop-onec { background: #ffc107; color: #856404; }\n.onec-service-btn.stop-onec:hover { background: #e0a800; }\n\n/* ============================================\n   СТАТУСЫ APACHE2 И КЛАСТЕРА\n============================================ */\n.apache-info-section, .cluster-info-section {\n  margin: 12px 0;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.apache-info-section {\n  background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);\n  border: 1px solid #b3d9ff;\n  border-left: 4px solid #4a90e2;\n}\n\n.cluster-info-section {\n  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);\n  border: 1px solid #d8b4fe;\n  border-left: 4px solid #9333ea;\n}\n\n.apache-status-row, .cluster-status-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.apache-status-row strong, .cluster-status-row strong {\n  min-width: 75px;\n  font-size: 13px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.apache-status-details, .cluster-status-details {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.apache-badge, .cluster-badge {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s;\n}\n\n.apache-badge.running, .cluster-badge.created {\n  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.apache-badge.stopped {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.apache-badge.not-installed, .cluster-badge.not-created {\n  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.apache-badge.installing, .cluster-badge.creating {\n  background: linear-gradient(135deg, #cce5ff 0%, #b3d9ff 100%);\n  color: #004085;\n  border: 1px solid #b3d9ff;\n  animation: pulse 1.5s infinite;\n}\n\n.apache-badge.error, .cluster-badge.error {\n  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(74, 144, 226, 0.4); }\n  50% { opacity: 0.85; box-shadow: 0 0 0 8px rgba(74, 144, 226, 0); }\n}\n\n.apache-install-btn {\n  padding: 5px 12px;\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);\n}\n\n.apache-install-btn:hover {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n}\n\n.apache-service-btn {\n  padding: 5px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.apache-service-btn.start-apache { background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%); color: white; }\n.apache-service-btn.start-apache:hover { background: linear-gradient(135deg, #3575c0 0%, #2a65a8 100%); transform: translateY(-1px); }\n.apache-service-btn.stop-apache { background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%); color: #856404; }\n.apache-service-btn.stop-apache:hover { background: linear-gradient(135deg, #e0a800 0%, #c69500 100%); transform: translateY(-1px); }\n\n.apache-status-message, .cluster-status-message {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.apache-status-message.success, .cluster-status-message.success {\n  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.apache-status-message.error, .cluster-status-message.error {\n  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.apache-status-message.info, .cluster-status-message.info {\n  background: linear-gradient(135deg, #e7f3ff 0%, #cce5ff 100%);\n  color: #004085;\n  border: 1px solid #b3d9ff;\n}\n\n/* ============================================\n   ПУСТОЕ СОСТОЯНИЕ\n============================================ */\n.full-empty-state {\n  text-align: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.full-empty-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  color: #dee2e6;\n}\n\n.full-empty-text {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 8px;\n}\n\n.full-empty-subtext {\n  color: #6c757d;\n  margin-bottom: 32px;\n}\n\n.add-server-btn {\n  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.add-server-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n}\n\n/* ============================================\n   МОДАЛЬНЫЕ ОКНА\n============================================ */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.2);\n}\n\n.lxc-modal {\n  max-width: 700px;\n}\n\n.modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #2c3e50;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.modal-header h3 i { color: #4a90e2; }\n\n.close-modal-btn {\n  background: none;\n  border: none;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #8a9bb5;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.close-modal-btn:hover:not(:disabled) {\n  background: #f8f9fa;\n  color: #dc3545;\n}\n\n.close-modal-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   ФОРМЫ В МОДАЛЬНЫХ ОКНАХ\n============================================ */\nform { padding: 24px; }\n\n.form-group { margin-bottom: 20px; }\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #495057;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\n}\n\n.form-group input:disabled,\n.form-group select:disabled,\n.form-group textarea:disabled {\n  background: #e9ecef;\n  cursor: not-allowed;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.password-input-group {\n  display: flex;\n  gap: 8px;\n}\n\n.password-input-group input { flex: 1; }\n\n.regenerate-password-btn {\n  width: 42px;\n  background: #e9ecef;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.regenerate-password-btn:hover:not(:disabled) {\n  background: #dee2e6;\n  color: #4a90e2;\n}\n\n.regenerate-password-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.password-hint {\n  display: block;\n  margin-top: 4px;\n  color: #ff6b6b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* ============================================\n   ИНФОРМАЦИЯ О КОНФИГУРАЦИИ И БАННЕР ШАБЛОНА\n============================================ */\n.specs-info {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 20px 0;\n}\n\n.specs-info h4 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  color: #495057;\n}\n\n.specs-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.spec-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  align-items: center;\n}\n\n.spec-label { color: #6c757d; }\n.spec-value { font-weight: 500; color: #2c3e50; }\n\n.workflow-info {\n  border-top: 1px solid #dee2e6;\n  padding-top: 12px;\n}\n\n.workflow-info p {\n  margin: 4px 0;\n  font-size: 13px;\n  color: #495057;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.workflow-info i { color: #4a90e2; }\n\n/* ✅ НОВЫЙ БАННЕР ИНФОРМАЦИИ О ШАБЛОНЕ */\n.template-info-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border: 1px solid #a5d6a7;\n  border-left: 4px solid #28a745;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.template-info-banner i {\n  font-size: 20px;\n  color: #28a745;\n  margin-top: 2px;\n}\n\n.template-info-banner strong {\n  color: #1b5e20;\n  font-size: 14px;\n  display: block;\n}\n\n.template-info-banner code {\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: #2e7d32;\n  font-weight: 600;\n}\n\n.template-info-banner small {\n  display: block;\n  margin-top: 6px;\n  color: #2e7d32;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n/* ============================================\n   СТАТУС СОЗДАНИЯ / ЗАПУСКА\n============================================ */\n.creation-status {\n  margin: 0 24px 24px 24px;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.creation-status.info {\n  background: #e7f3ff;\n  border-left: 4px solid #4a90e2;\n}\n\n.creation-status.success {\n  background: #d4edda;\n  border-left: 4px solid #28a745;\n}\n\n.creation-status.error {\n  background: #f8d7da;\n  border-left: 4px solid #dc3545;\n}\n\n.status-progress {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.step-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.step-icon.completed { background: #28a745; color: white; }\n.step-icon.current { background: #4a90e2; color: white; }\n.step-icon.pending { background: #e9ecef; color: #8a9bb5; }\n.step-icon.error { background: #dc3545; color: white; }\n\n.step-label {\n  font-size: 11px;\n  color: #6c757d;\n}\n\n.progress-line {\n  flex: 1;\n  height: 2px;\n  background: #e9ecef;\n  margin: 0 8px;\n  position: relative;\n}\n\n.progress-line-fill {\n  height: 100%;\n  background: #4a90e2;\n  transition: width 0.3s;\n}\n\n.progress-line-fill.filled { background: #28a745; }\n\n.status-message {\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: pre-line; /* ✅ Добавлено для корректного переноса строк из JS */\n}\n\n/* ============================================\n   КНОПКИ ДЕЙСТВИЙ В МОДАЛКЕ\n============================================ */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #e9ecef;\n  color: #495057;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background: #dee2e6;\n}\n\n.cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.submit-btn {\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #4a90e2 0%, #3575c0 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #3575c0 0%, #2a65a8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);\n}\n\n.submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ✅ Кнопка отправки для модалки запуска */\n.launch-submit-btn {\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;\n}\n\n.launch-submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%) !important;\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n}\n\n/* ============================================\n   ЗАГРУЗКА\n============================================ */\n.loading-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.spinner-large {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e9ecef;\n  border-top: 3px solid #4a90e2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n/* ============================================\n   АДАПТИВНОСТЬ\n============================================ */\n@media (max-width: 1024px) {\n  .sidebar { width: 220px; }\n  .lxc-grid { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); }\n}\n\n@media (max-width: 768px) {\n  .app { flex-direction: column; }\n  \n  .sidebar {\n    width: 100%;\n    height: auto;\n    position: static;\n    padding: 16px;\n  }\n  \n  .main-content { padding: 16px; }\n  \n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .user-info {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .user-details { align-items: flex-start; }\n  .content-grid, .lxc-grid { grid-template-columns: 1fr; }\n  \n  .lxc-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .form-row, .specs-grid { grid-template-columns: 1fr; }\n  \n  .status-progress {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 8px;\n  }\n  \n  .progress-line { display: none; }\n  .info-row strong { width: 100%; margin-bottom: 4px; }\n  .db-details { flex-direction: column; gap: 2px; }\n  .db-size, .db-type { white-space: normal; text-align: right; }\n  \n  .apache-status-row, .cluster-status-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n  \n  .apache-status-row strong, .cluster-status-row strong { min-width: auto; }\n  .apache-status-details, .cluster-status-details { width: 100%; justify-content: flex-start; }\n  .databases-items-static { max-height: 200px; }\n  .database-item-static { padding: 6px 8px; }\n  .db-details { margin-left: 18px; gap: 6px; }\n}\n\n@media (max-width: 480px) {\n  .modal-content { width: 95%; margin: 10px; }\n  .card-actions { flex-direction: column; }\n  .action-btn { width: 100%; }\n  .resources { grid-template-columns: 1fr; }\n  .database-item-static { flex-direction: column; align-items: flex-start; gap: 4px; }\n  .db-details { margin-left: 24px; flex-direction: row; }\n}\n\n/* ============================================\n   ДОПОЛНИТЕЛЬНЫЕ УТИЛИТЫ\n============================================ */\n.text-muted { color: #6c757d; }\n.text-success { color: #28a745; }\n.text-danger { color: #dc3545; }\n.text-warning { color: #ffc107; }\n.text-info { color: #4a90e2; }\n.mt-2 { margin-top: 8px; }\n.mb-2 { margin-bottom: 8px; }\n.ml-2 { margin-left: 8px; }\n.mr-2 { margin-right: 8px; }\n\n\n/* ============================================\n   СТИЛИ ДЛЯ СТРАНИЦЫ ВХОДА И РЕГИСТРАЦИИ\n============================================ */\n.auth-wrapper {\n  min-height: 100vh;\n  background: #0a0e1a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.auth-container {\n  display: flex;\n  width: 1200px;\n  max-width: 95vw;\n  min-height: 700px;\n  background: #111827;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.auth-info-panel {\n  width: 45%;\n  padding: 48px 40px;\n  background: linear-gradient(145deg, #1a1f35 0%, #0d1225 100%);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-info-panel::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.auth-brand {\n  margin-bottom: 48px;\n  position: relative;\n  z-index: 1;\n}\n\n.brand-icon { margin-bottom: 16px; }\n\n.brand-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n\n.brand-subtitle {\n  font-size: 16px;\n  color: #8b9bb5;\n  margin: 4px 0 16px 0;\n  font-weight: 400;\n}\n\n.brand-badge {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.badge-mvp {\n  display: inline-block;\n  padding: 4px 12px;\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.badge-status {\n  display: inline-block;\n  padding: 4px 12px;\n  background: rgba(102, 126, 234, 0.2);\n  color: #8b9bb5;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 20px;\n  border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.auth-features {\n  flex: 1;\n  position: relative;\n  z-index: 1;\n}\n\n.features-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #8b9bb5;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 20px;\n}\n\n.features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.features-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #c8d0e0;\n  font-size: 13px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  transition: all 0.3s ease;\n}\n\n.features-list li:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(102, 126, 234, 0.2);\n}\n\n.feature-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.feature-text {\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.auth-footer-info {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  position: relative;\n  z-index: 1;\n}\n\n.footer-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.footer-badge {\n  padding: 4px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 6px;\n  font-size: 11px;\n  color: #6b7d98;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.footer-version {\n  font-size: 12px;\n  color: #4a5a70;\n  margin: 0;\n}\n\n.auth-form-panel {\n  width: 55%;\n  padding: 48px 48px;\n  background: #111827;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-form-panel .auth-card {\n  width: 100%;\n  max-width: 400px;\n}\n\n.auth-header { margin-bottom: 32px; }\n\n.auth-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n  letter-spacing: -0.5px;\n}\n\n.auth-subtitle {\n  font-size: 15px;\n  color: #8b9bb5;\n  margin: 0;\n}\n\n.auth-error {\n  background: rgba(239, 68, 68, 0.1);\n  border-left: 3px solid #ef4444;\n  color: #fca5a5;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.auth-error i {\n  font-size: 16px;\n  color: #ef4444;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.auth-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.auth-form .form-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #b0bfd4;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.auth-form .form-group label i {\n  color: #4a6a8a;\n  font-size: 13px;\n}\n\n.auth-form .input-wrapper { position: relative; }\n\n.auth-form .input-wrapper input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #1a2236;\n  border: 1.5px solid #2a3650;\n  border-radius: 10px;\n  font-size: 15px;\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.auth-form .input-wrapper input::placeholder { color: #4a5a70; }\n\n.auth-form .input-wrapper input:focus {\n  border-color: #667eea;\n  background: #1e2840;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.auth-form .input-wrapper input.filled { border-color: #3a4a6a; }\n.auth-form .input-wrapper input:disabled { opacity: 0.5; cursor: not-allowed; }\n.auth-form .password-wrapper input { padding-right: 48px; }\n\n.auth-form .password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #4a5a70;\n  cursor: pointer;\n  padding: 4px 8px;\n  font-size: 16px;\n  transition: color 0.3s ease;\n}\n\n.auth-form .password-toggle:hover:not(:disabled) { color: #8b9bb5; }\n.auth-form .password-toggle:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #8b9bb5;\n  cursor: pointer;\n}\n\n.remember-me input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #667eea;\n  cursor: pointer;\n}\n\n.forgot-password {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.forgot-password:hover {\n  color: #7b93f5;\n  text-decoration: underline;\n}\n\n.auth-submit-btn {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.3);\n}\n\n.auth-submit-btn:active:not(:disabled) { transform: translateY(0); }\n.auth-submit-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }\n\n.auth-form .spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #ffffff;\n  border-radius: 50%;\n  animation: auth-spin 0.8s linear infinite;\n}\n\n@keyframes auth-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.auth-footer p {\n  color: #6b7d98;\n  font-size: 14px;\n  margin: 0;\n}\n\n.auth-link {\n  background: none;\n  border: none;\n  color: #667eea;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0 4px;\n  font-size: 14px;\n  transition: color 0.3s ease;\n}\n\n.auth-link:hover:not(:disabled) {\n  color: #7b93f5;\n  text-decoration: underline;\n}\n\n.auth-link:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.auth-system-info {\n  margin-top: 32px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.04);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.system-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  background: #22c55e;\n  border-radius: 50%;\n  animation: pulse-dot 2s infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.6; transform: scale(1.2); }\n}\n\n.status-text {\n  font-size: 13px;\n  color: #8b9bb5;\n}\n\n.system-metrics {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  color: #4a5a70;\n}\n\n.system-metrics span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (max-width: 1024px) {\n  .auth-container {\n    flex-direction: column;\n    max-height: none;\n    max-width: 100%;\n    margin: 20px;\n    border-radius: 16px;\n  }\n  .auth-info-panel, .auth-form-panel {\n    width: 100%;\n    padding: 32px 28px;\n  }\n  .auth-features .features-list { grid-template-columns: 1fr 1fr; }\n}\n\n@media (max-width: 640px) {\n  .auth-info-panel, .auth-form-panel { padding: 24px 20px; }\n  .auth-brand .brand-title { font-size: 24px; }\n  .auth-title { font-size: 22px; }\n  .auth-form .form-options {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n  .auth-system-info {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .footer-badges { flex-direction: column; gap: 6px; }\n  .system-metrics { flex-wrap: wrap; }\n  .auth-features .features-list { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 380px) {\n  .auth-container { margin: 10px; border-radius: 12px; }\n  .auth-info-panel, .auth-form-panel { padding: 20px 16px; }\n  .auth-features .features-list li { font-size: 12px; padding: 6px 10px; }\n  .auth-form .input-wrapper input { font-size: 14px; padding: 10px 14px; }\n  .auth-submit-btn { font-size: 14px; padding: 12px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
